import React from 'react';
import { Button } from '../../components';
import { Stack, Typography } from '@mui/material';
import { generateXeroState } from '../../utils/xeroAuthState';
import { XeroAuthLayout } from './XeroAuthLayout';
import { XERO_AUTH_STEP_INDEX } from './xeroAuthSteps';
import { XERO_COLORS, XERO_SPACING } from './xeroAuthStyles';

const buildXeroAuthUrl = (state) => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: '083F5A1851084CA1B10C7F92447801A4',
    redirect_uri: 'https://xero-auth.oligo.com.au/xero/user-auth-redirect',
    scope: 'accounting.settings accounting.payments accounting.invoices offline_access openid profile email',
    state,
  });
  return `https://login.xero.com/identity/connect/authorize?${params.toString()}`;
};

export const XeroUserAuthDashboard = () => {
  if (window.location.hostname !== 'xero-auth.oligo.com.au' && window.location.hostname !== 'localhost') {
    window.location = '/' + window.location.search;
    return null;
  }

  const handleContinue = () => {
    const state = generateXeroState();
    window.location.href = buildXeroAuthUrl(state);
  };

  return (
    <XeroAuthLayout activeIndex={XERO_AUTH_STEP_INDEX.connect}>
      <Stack gap={XERO_SPACING.page}>
        <Stack gap={XERO_SPACING.text}>
          <Typography variant="h5" fontWeight="600" color={XERO_COLORS.heading}>
            Connect Oligo to Xero
          </Typography>

          <Typography variant="body1" color="textSecondary">
            Connect your Xero organisation to Oligo.
          </Typography>
        </Stack>

        <Stack gap={XERO_SPACING.text}>
          <Typography variant="body1" fontWeight="600" color={XERO_COLORS.heading}>
            Before you continue
          </Typography>
          <Typography variant="body1" color="textSecondary">
            You will be taken to Xero to select your organisation and allow Oligo access.
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="flex-end">
          <Button $themeColor="#9b27d1" onClick={handleContinue} style={{ minWidth: '160px' }}>
            Continue to Xero
          </Button>
        </Stack>
      </Stack>
    </XeroAuthLayout>
  );
};
